import {useNavigate} from 'react-router'
import {Dropdown, DropdownItem, Icon, Layout, Text} from '@eitje/web_components'

const getFirstTo = taxonomy => {
	const entries = Object.entries(taxonomy)
	const [, navigationItem] = entries[0]
	const {to, modalLink, items} = navigationItem

	if (to) return to
	if (modalLink) return modalLink
	if (items) return getFirstTo(items)
}

const NavigationDropdownItems = ({taxonomy}) => {
	return Object.entries(taxonomy).map(([navigationItemName, {to, items, modalLink, enableRole, onClick}]) => {
		if (items)
			return (
				<Dropdown key={navigationItemName} trigger={{t: `navigation_header.${navigationItemName}`}}>
					<NavigationDropdownItems taxonomy={items} />
				</Dropdown>
			)

		return (
			<DropdownItem
				key={navigationItemName}
				t={`navigation_header.${navigationItemName}`}
				onClick={onClick}
				to={to}
				modalLink={modalLink}
				enableRole={enableRole}
			/>
		)
	})
}

export const NavigationDropdown = ({name, taxonomy, icon}) => {
	const defaultTo = getFirstTo(taxonomy)
	const navigate = useNavigate()

	return (
		<Layout className="navigation-dropdown">
			<Dropdown
				trigger={
					<Layout padding={16} onClick={() => navigate(defaultTo)}>
						{icon ? <Icon name={icon} /> : <Text t={`navigation_header.${name}`} />}
					</Layout>
				}
				triggerEvent="hover"
			>
				<NavigationDropdownItems taxonomy={taxonomy} />
			</Dropdown>
		</Layout>
	)
}
